{
  "version": 1,
  "asset_id": "9a941bca-31b5-4b03-b74c-7baeae87eac1",
  "project_id": "1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955",
  "url": "/__l5e/assets-v1/9a941bca-31b5-4b03-b74c-7baeae87eac1/screen-enclosure-exterior.jpg",
  "r2_key": "a/v1/1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955/9a941bca-31b5-4b03-b74c-7baeae87eac1/screen-enclosure-exterior.jpg",
  "original_filename": "screen-enclosure-exterior.jpg",
  "size": 952959,
  "content_type": "image/jpeg",
  "created_at": "2026-09-09T15:28:00Z"
}
